<template>
<div class="chapter">
<div class="inner_page">
<p class="C111"><strong><a id="page_ix">CONTENTS</a></strong></p><a id="page_ix">
</a><p class="C114"><a id="page_ix"></a><a href="#/xhtml/06_1__Revolution#page_1"><strong>1.</strong> Revolution</a></p>
<p class="C114"><a href="#/xhtml/07_2__Love_s_Dimensions#page_16"><strong>2.</strong> Love’s Dimensions</a></p>
<p class="C114"><span href="#/xhtml/08_3__Human_Natures#page_36" title="Link target outside of Sample"><strong>3.</strong> Human Natures</span></p>
<p class="C114"><span href="#/xhtml/09_4__Little_Heart_Shaped_Pills#page_52" title="Link target outside of Sample"><strong>4.</strong> Little Heart-Shaped Pills</span></p>
<p class="C114"><span href="#/xhtml/10_5__Good_Enough_Marriages#page_71" title="Link target outside of Sample"><strong>5.</strong> Good-Enough Marriages</span></p>
<p class="C114"><span href="#/xhtml/11_6__Ecstasy_as_Therapy#page_82" title="Link target outside of Sample"><strong>6.</strong> Ecstasy as Therapy</span></p>
<p class="C114"><span href="#/xhtml/12_7__Evolved_Fragility#page_101" title="Link target outside of Sample"><strong>7.</strong> Evolved Fragility</span></p>
<p class="C114"><span href="#/xhtml/13_8__Wonder_Hormone#page_110" title="Link target outside of Sample"><strong>8.</strong> Wonder Hormone</span></p>
<p class="C114"><span href="#/xhtml/14_9__Anti_love_Drugs#page_121" title="Link target outside of Sample"><strong>9.</strong> Anti-love Drugs</span></p>
<p class="C114"><span href="#/xhtml/15_10__Chemical_Breakups#page_136" title="Link target outside of Sample"><strong>10.</strong> Chemical Breakups</span></p>
<p class="C114"><span href="#/xhtml/16_11__Avoiding_Disaster#page_149" title="Link target outside of Sample"><strong>11.</strong> Avoiding Disaster</span></p>
<p class="C114"><span href="#/xhtml/17_12__Choosing_Love#page_171" title="Link target outside of Sample"><strong>12.</strong> Choosing Love</span></p>
<p class="C115"><span href="#/xhtml/18_Epilogue__Pharmacopeia#page_189" title="Link target outside of Sample">Epilogue: Pharmacopeia</span></p>
<p class="C114"><em><span href="#/xhtml/19_Acknowledgments#page_191" title="Link target outside of Sample">Acknowledgments</span></em></p>
<p class="C114"><em><span href="#/xhtml/20_Notes#page_195" title="Link target outside of Sample">Notes</span></em></p>
<p class="C114"><em><span href="#/xhtml/21_Index#page_255" title="Link target outside of Sample">Index</span></em></p>
<p class="C114"><em><span href="#/xhtml/22_About_the_Authors#page_267" title="Link target outside of Sample">About the Authors</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?ca588028